import { Link } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import Breadcrumb from '@/components/base/Breadcrumb';
import ArticleCard from '@/components/base/ArticleCard';
import usePageMeta from '@/hooks/usePageMeta';
import { articles, categories } from '@/mocks/articles';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'CollectionPage',
  name: '看料99 全部分类',
  description: '看料99 覆盖娱乐爆料、社会观察、职场内幕、生活见闻四大内容方向。',
  url: 'https://lfthg.cn/category',
};

export default function CategoryIndex() {
  usePageMeta({
    title: '全部分类 - 看料99 独家料与首发资源汇总',
    description:
      '按主题浏览看料99 全部内容分类，涵盖娱乐爆料、社会观察、职场内幕与生活见闻，每条线索都附时间线与背景整理，方便你快速找到想看的方向。',
    keywords: '看料99分类,看料99独家料,看料99首发资源,娱乐爆料,社会观察,职场内幕',
    path: '/category',
    jsonLd,
  });

  return (
    <SiteLayout>
      <div className="animate-fade-up">
        <section className="border-b border-background-200 bg-background-100">
          <div className="mx-auto w-full max-w-[1280px] px-4 py-8 md:px-6 md:py-12">
            <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '全部分类' }]} />
            <h1 className="mt-4 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
              看料99 内容分类
            </h1>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              我们按主题把内容分成四个方向，每个方向都持续更新。选择一个分类，顺着时间线把一条线索读完。
            </p>
          </div>
        </section>

        <div className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-6 md:py-14">
          <div className="space-y-12">
            {categories.map((c) => {
              const list = articles.filter((a) => a.category === c.slug).slice(0, 3);
              return (
                <section key={c.slug} aria-label={c.name}>
                  <div className="flex flex-wrap items-end justify-between gap-3">
                    <div className="flex items-center gap-3">
                      <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                        <i className={`${c.icon} text-xl`} aria-hidden="true"></i>
                      </span>
                      <div>
                        <h2 className="font-heading text-xl font-semibold text-foreground-950 md:text-2xl">
                          {c.name}
                        </h2>
                        <p className="mt-1 max-w-2xl text-sm text-foreground-600">{c.desc}</p>
                      </div>
                    </div>
                    <Link
                      to={`/category/${c.slug}`}
                      className="inline-flex items-center gap-1 rounded-md border border-background-300 px-3 py-2 text-sm text-foreground-700 whitespace-nowrap transition-colors hover:border-primary-300 hover:text-primary-600"
                    >
                      查看全部
                      <i className="ri-arrow-right-line" aria-hidden="true"></i>
                    </Link>
                  </div>
                  <div className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
                    {list.map((a) => (
                      <ArticleCard key={a.id} article={a} />
                    ))}
                  </div>
                </section>
              );
            })}
          </div>
        </div>
      </div>
    </SiteLayout>
  );
}